export default __webpack_public_path__ + "static/media/massup_m3.b55e36d5.png";